import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ErrorMessageComponent } from '../../general/error/error-message.component';
import { SuccessMessageComponent } from '../../general/success/success-message.component';
import { PrimengModule } from '../primeng-module/primeng.module';
import { ErrorMessageV2Component, ErrorMessageV3Component } from '../../general/error/versions/error-message-versions.component';

@NgModule({
  declarations: [
    ErrorMessageV2Component,
    ErrorMessageV3Component,
    ErrorMessageComponent,
    SuccessMessageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PrimengModule
  ],
  exports: [
    ErrorMessageComponent,
    SuccessMessageComponent
  ]
})
export class SharedMessagesModule { }
